import React from 'react';
import moment from 'moment/moment';
import { COMPLETED } from '../../../../constants/travelExpenseStatus';

const ManagerApprove = request => (
  <div className="content table-responsive table-full-width">
    <table className="table table-hover table-bordered">
      <tbody>
        <tr>
          <td>
          Yönetici Onay Tarihi
          </td>
          <td id="managerApprovalDate">
            {moment(new Date(request.request.confirmationDate))
              .format('DD-MM-YYYY HH:mm')}
          </td>
        </tr>
        {request.request.status === COMPLETED
          ? (
            <tr>
              <td>
              Kur bilgisi
              </td>
              <td id="costDetailExchangeRate">
                {request.request.exchangeRate}
              </td>
            </tr>
          )
          : null

      }

      </tbody>
    </table>
  </div>
);
export default ManagerApprove;



// WEBPACK FOOTER //
// ./src/components/travel-expense/detail/manager-approve/index.js